import { useState } from 'react';

import { ArrowRight02Icon, IdVerifiedIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { useOAuth } from 'hooks/oauth';
import { useTranslation } from 'react-i18next';
import { CustomButton } from 'views/CandidateApp/components/CustomButton/CustomButton';

import { IconComponent } from 'components/Icon/IconComponent';

const LinkedinVerification = ({
  brand,
  refereeFirstName,
  candidateName,
  companyName,
  onLinkedinCode = () => {},
  onSkip = () => {},
}) => {
  const { t } = useTranslation();
  const [authError, setAuthError] = useState(false);

  const openLinkedinAuth = useOAuth({
    authUri: 'https://www.linkedin.com/oauth/v2/authorization',
    clientId: '78s6flqajccq2v',
    responseType: 'code',
    redirectUri: `${process.env.REACT_APP_WEB_URL}/assets/linkedin_callback.html`,
    scope: 'openid profile email',
    callbackAction: 'linkedin_callback',
    callback: onLinkedinCode,
    onError: () => setAuthError(true),
  });

  return (
    <div className="w-full bg-white flex flex-col items-center px-6 pt-28 pb-8 md:px-16 md:pt-32 md:pb-12">
      <div className="w-full md:w-[420px] flex flex-col gap-8">
        <IconComponent icon={IdVerifiedIcon} type="default" size="xlarge" border={false} />
        <div className="flex flex-col gap-2">
          <h1 className="text-neutral-7 text-5xl font-regular inter-font leading-snug">
            {t('refereeForm.linkedinVerification.heading', { name: refereeFirstName })}
          </h1>
          {candidateName && companyName && (
            <p className="text-neutral-6 text-2xl font-light">
              {t('refereeForm.linkedinVerification.subtitle', {
                candidate: candidateName,
                company: companyName,
              })}
            </p>
          )}
        </div>
        <div className="flex flex-col gap-4">
          <button
            type="button"
            onClick={openLinkedinAuth}
            data-testid="linkedin-connect-button"
            className="w-full h-[52px] rounded-full border border-blue-3 text-blue-3 font-medium flex items-center justify-center gap-2 hover:bg-blue-1 transition-colors text-[16px]">
            <img src="/assets/images/linkedin-logo.png" alt="" className="h-10 w-12" />
            {t('refereeForm.linkedinVerification.LinkedinButton')}
            <HugeiconsIcon icon={ArrowRight02Icon} size={18} strokeWidth={2} />
          </button>
          <CustomButton
            brand={brand}
            onClick={onSkip}
            marginTop={false}
            icon="arrow-right"
            prependIcon={false}
            dataTestId="linkedin-skip-button">
            {t('refereeForm.linkedinVerification.continueWithEmail')}
          </CustomButton>
          <p className="text-text-tertiary text-xl font-light">
            {t('refereeForm.linkedinVerification.disclaimer')}
          </p>
        </div>
        {authError && (
          <p className="text-text-error text-xs">{t('refereeForm.linkedinVerification.error')}</p>
        )}
      </div>
    </div>
  );
};

export default LinkedinVerification;
